import { useEffect, useState } from "react";
import { X } from "lucide-react";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=in.shipany.app";

export default function InstallApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone || localStorage.getItem("android-app-dismissed")) return undefined;
    const t = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem("android-app-dismissed", "1");
    setVisible(false);
  };

  return (
    <div data-testid="android-app-banner"
      className="fixed bottom-4 right-4 z-[60] flex w-[320px] items-center gap-3 rounded-2xl border border-white/10 bg-shipany-navy p-4 shadow-2xl">
      <img src="/pwa-icon-192.png" alt="ShipAny app icon" className="h-11 w-11 rounded-xl" />
      <div className="min-w-0 flex-1">
        <p className="font-display text-sm font-bold text-white">Get the ShipAny Android App</p>
        <p className="text-[11px] text-slate-400">Book, track and manage shipments from your phone.</p>
        <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer" data-testid="android-app-download-btn"
          className="mt-2 inline-flex items-center gap-1.5 rounded-lg bg-gradient-to-r from-[#FF9933] to-[#FF8000] px-3.5 py-1.5 text-xs font-bold text-[#071B3A]">
          <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-current" aria-hidden="true"><path d="M3.6 2.3 13.7 12 3.6 21.7c-.3-.2-.5-.6-.5-1V3.3c0-.4.2-.8.5-1zM15.5 10.2 5.9 2.8l11 6.2-1.4 1.2zm0 3.6 1.4 1.2-11 6.2 9.6-7.4zm2.5-1.4 2.2 1.2c.6.4.6 1.2 0 1.6L18 12.8l-1.5-1.3L18 10.2z"/></svg>
          Download on Google Play
        </a>
      </div>
      <button onClick={dismiss} data-testid="android-app-dismiss" aria-label="Dismiss app banner"
        className="self-start rounded-lg p-1 text-slate-400 hover:bg-white/10 hover:text-white">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
